import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import React from "react";
import "../../style";
import { validateForm } from "./FormValidator";

var count = 0;

class InputFiled extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value ? props.value : "",
      errorMessage: ""
    };
  }
  componentWillMount = () => {
    this.id = this.newId();
  };
  newId = () => {
    count++;
    return `input_${count}_unique_id`;
  };
  // handlechange = (event) => {
  //   let { name, value } = event.target;
  //   this.props.handleChange(event)
  // }
  onBlurFocus = () => {
    const {
      name,
      value,
      validations,
      label,
      handleError,
      placeholder,
      type
    } = this.props;
    let error = validateForm(label, value, validations, placeholder, type);
    handleError && handleError(name, error);
    this.setState({ errorMessage: error });
  };
  onChangeHandler = e => {
    const { name, validations, label, handleError, handleChange } = this.props;
    const value = e.target.value;
    handleChange(e);
    let error = validateForm(label, value, validations);
    handleError && handleError(name, error);
    this.setState({ errorMessage: error });
  };
  render() {
    const {
      label,
      placeholder,
      // errorMessage,
      required,
      // value,
      name,
      type,
      disabled,
      format,
      handleChange,
      rows,
      rowsMax,
      multiline,
      fieldError,
      styleClass,
      handleClick,
      InputProps
    } = this.props;
    let { value } = this.props;
    const { errorMessage } = this.state;
    const isError = errorMessage.length > 0 && errorMessage !== "valid";

    if (type === "number" && isNaN(value)) {
      value = null;
    }
    return (
      <div>
        <FormControl
          variant="outlined"
          className={`formControl  ${styleClass}`}
        >
          {label && (
            <label htmlFor={this.id}>
              {label} {required ? "*" : ""}
            </label>
          )}
          <TextField
            id={this.id}
            placeholder={placeholder}
            // className={`${errorMessage ? 'haserror' : ''}`}
            value={value === null ? "" : value}
            fullWidth
            className={`inputField ${disabled ? "disabledInput" : ""}`}
            required={required}
            onChange={this.onChangeHandler}
            margin="normal"
            variant="outlined"
            InputProps={InputProps || { inputProps: { min: 0 } }}
            error={isError && fieldError !== ""}
            name={name}
            type={type}
            disabled={disabled}
            format={format}
            onBlur={this.onBlurFocus}
            multiline={multiline}
            rows={rows}
            rowsMax={rowsMax}
            onClick={handleClick}
            autoComplete="off"
            // labelWidth={0}
          />

          {isError && fieldError !== "" && (
            <FormHelperText id="component-error-text">
              <span className="error" role="alert">
                {errorMessage}
              </span>
            </FormHelperText>
          )}
        </FormControl>
      </div>
    );
  }
}
InputFiled.propTypes = {
  styleClass: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired
};
export default InputFiled;



// WEBPACK FOOTER //
// ./src/components/FormElement/InputFiled.js